export const FIELD_TYPES = Object.freeze({
  TEMPORAL: "temporal",
  CONTEXT: "context_dimension",
  BREAKDOWN: "breakdown_dimension",
  ADDITIVE_METRIC: "additive_metric",
  NON_ADDITIVE_METRIC: "non_additive_metric",
  METADATA: "metadata_technical",
  UNSUPPORTED: "unsupported_structured_value",
  DIMENSION: "breakdown_dimension",
  METRIC: "additive_metric",
});

export const METRIC_AGGREGATION_POLICIES = Object.freeze({
  SUM: "sum",
  NONE: "none",
});
